module.exports = __webpack_public_path__ + "static/media/girl6.2f4f6434.jpg";